<button class="btn-primary" (click)="triggerScroll('contactSection')">
    {{ text }}
</button>